// export const googleMapsApiKey = "AIzaSyAELg8lK4UgbRqTP2i4Mb-vqZtEGY_Gink" /// Client (kp) ////
export const googleMapsApiKey = "AIzaSyBfu7BJhQA3KMO6FSfXpzb2sqy_GomzFn8" // arga (shiv bhai (Date: 12-11-24)) ///// 
